export enum AttendanceStates {
  attended = 'Attended',
  therapistCancelled = 'Cancelled by Therapist',
  patientCancelled = 'Cancelled by Patient',
  rescheduled = 'Rescheduled',
  dna = 'Did not attend',
  other = 'Other'
}
